import { useState, useEffect } from 'react'

interface AutoReplyConfig {
  basic_timeout: number
  basic_message: string
  standard_timeout: number
  standard_message: string
  pro_timeout: number
  pro_message: string
}

interface UseAutoReplyTimerProps {
  autoReplyConfig?: AutoReplyConfig
  subscription?: 'BASIC' | 'STANDARD' | 'PRO'
  onTimeout: (message: string) => void
}

export const useAutoReplyTimer = ({ autoReplyConfig, subscription = 'BASIC', onTimeout }: UseAutoReplyTimerProps) => {
  const [timeLeft, setTimeLeft] = useState<string | null>(null)

  useEffect(() => {
    if (!autoReplyConfig) {
      return
    }

    let timeout: number
    let message: string

    switch (subscription) {
      case 'BASIC':
        timeout = autoReplyConfig.basic_timeout
        message = autoReplyConfig.basic_message
        break
      case 'STANDARD':
        timeout = autoReplyConfig.standard_timeout
        message = autoReplyConfig.standard_message
        break
      case 'PRO':
        timeout = autoReplyConfig.pro_timeout
        message = autoReplyConfig.pro_message
        break
      default:
        timeout = autoReplyConfig.basic_timeout
        message = autoReplyConfig.basic_message
    }

    const endTime = new Date(Date.now() + timeout * 60 * 1000) // Convert minutes to milliseconds

    const updateTimer = () => {
      const now = new Date()
      const diff = endTime.getTime() - now.getTime()

      if (diff <= 0) {
        setTimeLeft(null)
        onTimeout(message)
        return
      }

      const minutes = Math.floor(diff / (1000 * 60))
      const seconds = Math.floor((diff % (1000 * 60)) / 1000)
      setTimeLeft(`${minutes}:${seconds.toString().padStart(2, '0')}`)
    }

    const timerId = setInterval(updateTimer, 1000)
    updateTimer() // Initial update

    return () => {
      clearInterval(timerId)
    }
  }, [autoReplyConfig, subscription, onTimeout])

  return { timeLeft }
} 